import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  markNotificationsAsRead(
    request: Boundaries["markNotificationsAsRead"]["request"],
  ): void;
}

function useMarkNotificationsAsRead(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isMarkNotificationsAsReadRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isMarkNotificationsAsReadRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isMarkNotificationsAsReadRequestFailure,
    ),
    markNotificationsAsRead: core.markNotificationsAsRead,
  };
}

export { useMarkNotificationsAsRead };
